import { useDataView } from "../../contexts/data.view.context";
import AppDialog from "../util/appDialog";
import ViewDetailsIcon from "../util/detailsModal/viewDetailsIcon";
import ViewEditAPIConfig from "./viewEditApiConfig";

const viewDetailsModal = ({ detailData }) => {
  return function ({ cell, row }) {
    const {
      openDetailForm,
      editable,
      curRow,
      handleClickOpenDetail,
      handleDetailClose,
      onEditClick,
    } = useDataView();

    const cellValue = cell.getValue();
    const tooltip = "View Details";

    return (
      <>
        <ViewDetailsIcon
          row={row}
          tooltip={tooltip}
          onClick={handleClickOpenDetail}
        />
        {cellValue}
        <AppDialog
          open={openDetailForm}
          onClose={handleDetailClose}
          title="API Config Details"
          maxWidth="sm"
        >
          <ViewEditAPIConfig
            curRow={curRow.current}
            handleDetailClose={handleDetailClose}
            editable={editable}
            onEditClick={onEditClick}
            data={detailData}
          />
        </AppDialog>
      </>
    );
  };
};

export default viewDetailsModal;
